import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isSummaryDetailsLoading: false,
  summaryDetails: '',

  isSummaryListLoading: false,
  summaryList: [],

  icd10SummaryLoading: false,
  icd10UpdatedAt: '',
  icd10Summary: [],

  isSummaryRegenerationLoading: false,
  summaryExportLoading: false,
  summaryRating: 0,

  cptCodesSummaryLoading: false,
  cptCodesSummary: [],
  cptCodesUpdatedAt: '',
  dictateSummaryLoading: false,
  dictateSummary: [],

  // SNOMED codes
  snomedCodesSummaryLoading: false,
  snomedCodesSummary: [],
  snomedCodesUpdatedAt: '',

  magicEditSuggestions: {},
};

const summarySlice = createSlice({
  name: 'summarySlice',
  initialState,
  reducers: {
    summaryDetailsLoading: (state, { payload }) => {
      state.isSummaryDetailsLoading = payload;
    },
    summaryDetailsSlice: (state, { payload }) => {
      state.summaryDetails = payload;
    },
    summaryListLoading: (state, { payload }) => {
      state.isSummaryListLoading = payload;
    },
    summaryListSlice: (state, { payload }) => {
      state.summaryList = payload;
    },
    icd10SummaryLoading: (state, { payload }) => {
      state.icd10SummaryLoading = payload;
    },
    icd10SummarySlice: (state, { payload }) => {
      state.icd10Summary = payload;
    },
    icd10UpdatedAtSlice: (state, { payload }) => {
      state.icd10UpdatedAt = payload;
    },
    dictateSummaryLoading: (state, { payload }) => {
      state.dictateSummaryLoading = payload;
    },
    dictateSummarySlice: (state, { payload }) => {
      state.dictateSummary = payload;
    },
    cptCodesSummarySlice: (state, { payload }) => {
      state.cptCodesSummary = payload;
    },
    cptCodesSummaryLoading: (state, { payload }) => {
      state.cptCodesSummaryLoading = payload;
    },
    cptCodesUpdatedAtSlice: (state, { payload }) => {
      state.cptCodesUpdatedAt = payload;
    },
    summaryRegenerationLoading: (state, { payload }) => {
      state.isSummaryRegenerationLoading = payload;
    },
    summaryExportLoading: (state, { payload }) => {
      state.summaryExportLoading = payload;
    },
    resetSummaryState: () => {
      return initialState;
    },
    summaryRatingSlice: (state, { payload }) => {
      state.summaryRating = payload;
    },
    magicEditSuggestionsSlice: (state, { payload }) => {
      state.magicEditSuggestions = payload;
    },
    snomedCodesSummarySlice: (state, { payload }) => {
      state.snomedCodesSummary = payload;
    },
    snomedCodesSummaryLoading: (state, { payload }) => {
      state.snomedCodesSummaryLoading = payload;
    },
    snomedCodesUpdatedAtSlice: (state, { payload }) => {
      state.snomedCodesUpdatedAt = payload;
    },
  },
});

const { actions, reducer } = summarySlice;

export const {
  summaryDetailsLoading,
  summaryDetailsSlice,
  summaryListLoading,
  summaryListSlice,
  icd10SummaryLoading,
  icd10SummarySlice,
  icd10UpdatedAtSlice,
  summaryRegenerationLoading,
  summaryExportLoading,
  resetSummaryState,
  summaryRatingSlice,
  cptCodesSummarySlice,
  cptCodesSummaryLoading,
  cptCodesUpdatedAtSlice,
  dictateSummaryLoading,
  dictateSummarySlice,
  magicEditSuggestionsSlice,
  snomedCodesSummarySlice,
  snomedCodesSummaryLoading,
  snomedCodesUpdatedAtSlice,
} = actions;

export default reducer;
